/**
 * DecisionBanner - Read-only banner showing existing decision
 * PRD format: "Decision Recorded: [Approved / Rejected] by [Officer Name] on [Date & Time]"
 */

import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
import type { DecisionBannerProps } from '../../../../types/lending-report.types';

export const DecisionBanner: React.FC<DecisionBannerProps> = ({ decision }) => {
  const isApproved = decision.decision === 'APPROVED';
  const formattedDate = new Date(decision.decidedAt).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  const bgColor = isApproved ? '#f0fdf4' : '#fef2f2';
  const borderColor = isApproved ? '#86efac' : '#fecaca';
  const iconColor = isApproved ? '#16a34a' : '#dc2626';
  const labelColor = isApproved ? '#15803d' : '#b91c1c';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '14px 16px',
        borderRadius: '12px',
        border: `2px solid ${borderColor}`,
        backgroundColor: bgColor,
      }}
    >
      {isApproved ? (
        <CheckCircle style={{ width: 22, height: 22, color: iconColor, flexShrink: 0 }} />
      ) : (
        <XCircle style={{ width: 22, height: 22, color: iconColor, flexShrink: 0 }} />
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <span style={{ fontSize: '14px', fontWeight: 700, color: labelColor }}>
          Decision Recorded:{' '}
        </span>
        <span style={{ fontSize: '14px', fontWeight: 600, color: '#111827' }}>
          {isApproved ? 'Approved' : 'Rejected'}
        </span>
        <span style={{ fontSize: '13px', color: '#6b7280' }}>
          {' '}by {decision.decidedByName || decision.decidedBy} on {formattedDate}
        </span>
      </div>
    </div>
  );
};
